import { exportBiometricLicense } from "../models/exportBiometricLicense";
import { genericError } from "../models/GenericError";
import { StoreEntityResult } from "../models/services/StoreEntityResult";
import { APIConnector } from "./api/APIConnector";
import { processServerError, getConstraintViolation } from "./utilities/ServiceError";

const apiConnector = new APIConnector();

export const getExportedBiometricLicense = async (): Promise<exportBiometricLicense> => {
    try {
        const newRecord = {
            type: 'biometricLicense',
            attributes: {
                contentType: "BYTES"
            }
        }

        const response = await apiConnector.sendData('', true, newRecord, true);
        const json = await response.json();

        return new Promise(async (resolve, reject) => {
            if (json.errors) {
                return reject({ status: response.status, message: getConstraintViolation(json.errors[0].detail) })
            }

            const hasFile = (json['attributes']['file'] != null);
            const exportLicense: exportBiometricLicense = {
                id: 0,
                contentType: json['attributes']['contentType'],
                processedCount: json['attributes']['processedCount'],
                fileType: !hasFile ? '' : json['attributes']['file']['fileType'],
                fileName: !hasFile ? '' : json['attributes']['file']['fileName'],
                fileContentBytes: !hasFile ? [] : json['attributes']['file']['fileContentBytes'],
                fileSize: !hasFile ? '' : json['attributes']['file']['fileSize'],
                type: json['type'],
            }

            return resolve(exportLicense);
        })
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error));
        });
    }
}

export const importBiometricLicense = async (importedLicense: any): Promise<StoreEntityResult> => {
    try {
        const newRecord = {
            type: "biometricLicense",
            attributes: {
                file: {
                    fileContentBytes: importedLicense
                }
            }
        }

        let response;
        await apiConnector.sendData('', true, newRecord, true).then(data => {
            response = data;
        }).catch(error => {
            return new Promise((resolve, reject) => {
                reject(processServerError(error));
            });
        });

        const json = await response.json();
        return new Promise<StoreEntityResult>(async (resolve, reject) => {
            if (json && json.errors) {
                return reject({ status: response.status, message: getConstraintViolation(json.errors[0].detail) })
            }

            if (response) {
                if (response.errors) {
                    return reject({ status: response.status, message: getConstraintViolation(response.errors[0].detail) })
                }

                return resolve({ id: 0, success: true });
            }

            return reject({ status: response.status, message: genericError });
        })
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error));
        });
    }
}
